import * as types from "../types";
import content from "../../assets/contentJson";
const initState = {
  gemId1:"",
  gemId2:"",
  channelCode:"",
  cardName:"",
  cardList: [],
  bannerList: {},
  cardListFeteched: false,
  appContent: content,
};

const AppStateReducer = (state = initState, action) => {
  switch (action.type) {
    case types.SAVE_LG_QUERY_PARAMS:
      return {
        ...state,
        gemId1: action.payload.gemId1,
        gemId2: action.payload.gemId2,
        channelCode: action.payload.channelCode,
        cardName: action.payload.cardName,
      };
      case types.SET_CND_CONTENT:
        return {
          ...state,
          cardList: action.payload.cardList,
          bannerList: action.payload.bannerContent, 
          cardListFeteched: true,
        };

      case types.SET_APP_CONTENT:
        return {
          ...state,
          appContent: action.payload,
        };  
    default:
      return state;
  }
};

export default AppStateReducer;
